<mat-tab-group
  animationDuration="0ms"
  [(selectedIndex)]="selectedTabIndex"
  (selectedIndexChange)="onTabChange($event)"
>
  <mat-tab label="Project Info">
    <app-overview></app-overview>
    <app-contracts></app-contracts>
  </mat-tab>
  <mat-tab label="Contract">
    <app-contracts></app-contracts>
  </mat-tab>
  <mat-tab label="Scope Of Work">
    <app-scope-work></app-scope-work>
  </mat-tab>
  <mat-tab label="Insurance">
    <app-insurance></app-insurance>
  </mat-tab>
  <mat-tab label="Contractors">
    <app-contractor></app-contractor>
  </mat-tab>
  <mat-tab label="Sub Contractors">
    <app-sub-contractor></app-sub-contractor>
  </mat-tab>
  <mat-tab label="Suppliers">
    <app-suppliars></app-suppliars>
  </mat-tab>
  <mat-tab label="Payment">
    <app-payment></app-payment>
  </mat-tab>
  <mat-tab label="Changes">
    <app-change></app-change>
  </mat-tab>
</mat-tab-group>
